<template>
  <div class="home">
    <b-row v-if="true">
      <b-col cols="12">
        <!--TODO: Please fix this on the back end. JSON serializations are not working correctly.-->
        <h2 class="text-black" style="color:#0e2039">Hello, {{ this.user['name'].replaceAll('"', '') }}</h2>
        <h3>Welcome to LCS Gateway. Your ultimate supply chain and logistics framework and online portal.
          <!--          <b-icon  icon="BIconStickiesFill"></b-icon>-->
        </h3>
        <br />
        <img src="@/assets/gateway-banner-03.jpg" alt="" width="100%">
      </b-col>
    </b-row>
    <br />
    <b-row v-if="true">
      <b-col cols="12">
        <h4
          style="text-align: center; background: #1d3454; color: #fff; padding: 16px 30px; border-radius: 3px 3px 0 0; ">
          Favourites</h4>
        <br />
      </b-col>
      <!-- removing feature for selected items in favourites-->
      <b-col cols="6" sm="4" xl="2" v-for="(favourite, index) in favourites" :key="index">
        <b-card class="cursor menu-card-outline" @click="navigateTo(favourite.link)">
          <h1 class="text-center"><img :src="url + favourite.link.icon" alt="" class="menu-item-img"></h1>
          <h6 class="mb-0 pb-0 text-center menu-item-names">{{ favourite.link.name }}</h6>
          <div class="text-right">
            <b-dropdown no-caret size="sm" class="home-dropdown">
              <template #button-content>
                <b-icon-three-dots></b-icon-three-dots>
              </template>
              <b-dropdown-item v-on:click.stop="removeFav(favourite)">Remove from favourites</b-dropdown-item>
            </b-dropdown>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" v-for="(menuItem, index) in menu" :key="index">
        <br />
        <h4
          style="text-align: center; background: #4e5760; color: #fff; padding: 16px 30px; border-radius: 3px 3px 0 0; ">
          {{ menuItem.name }}
        </h4>
        <br />
        <b-row>
          <template v-if="!menuItem.showSubMenu">
            <b-col cols="6" sm="4" xl="2" v-for="(app, linkIndex) in menuItem.links" :key="linkIndex">
              <b-card class="cursor menu-card-outline" @click="navigateTo(app)">
                <h1 class="text-center">
                  <img :src="url + app.icon" alt="" class="menu-item-img" />
                </h1>
                <h6 class="mb-0 pb-0 text-center menu-item-names">{{ app.name }}</h6>
                <div class="text-right">
                  <b-dropdown no-caret size="sm" class="home-dropdown">
                    <template #button-content>
                      <b-icon-three-dots></b-icon-three-dots>
                    </template>
                    <!-- add items in favourites-->
                    <b-dropdown-item v-on:click.stop="addToFavourites(app)">
                      Add to favourites
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card>
            </b-col>
            <b-col cols="6" sm="4" xl="2" v-for="(submenu, submenuIndex) in menuItem.children" :key="submenuIndex">
              <b-card class="cursor menu-card-outline">
                <h1 class="text-center">
                  <img src="https://gatewayapi.lcsgroup.co.za/Cdn/Get/181/documents-icon-03.gif" alt="" class="menu-item-img" />
                </h1>
                <h6 class="mb-0 pb-0 text-center menu-item-names">{{ submenu.name }}</h6>
                <div class="text-right">
                  <b-dropdown no-caret size="sm" class="home-dropdown">
                    <template #button-content>
                      <b-icon-three-dots></b-icon-three-dots>
                    </template>
                    <b-dropdown-item v-on:click.stop="toggleSubMenu(menuItem, submenu)"> Show Links </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card>
            </b-col>
            <!-- Add an empty b-col to fill the row when the submenu is not enough to fill the row -->
            <b-col v-if="menuItem.children && (menuItem.links.length % 6 !== 0)">
              &nbsp;
            </b-col>
          </template>
          <template v-else>
            <b-col cols="6" sm="4" xl="2" v-for="(app, linkIndex) in selectedSubMenu.links" :key="linkIndex">
              <b-card class="cursor menu-card-outline" @click="navigateTo(app)">
                <h1 class="text-center">
                  <img :src="url + app.icon" alt="" class="menu-item-img" />
                </h1>
                <h6 class="mb-0 pb-0 text-center menu-item-names">{{ app.name }}</h6>
                <div class="text-right">
                  <b-dropdown no-caret size="sm" class="home-dropdown">
                    <template #button-content>
                      <b-icon-three-dots></b-icon-three-dots>
                    </template>
                    <b-dropdown-item v-on:click.stop="toggleSubMenu(menuItem, null)">
                      Back to Main Menu
                    </b-dropdown-item>
                    <b-dropdown-item v-on:click.stop="addToFavourites(app)">
                      Add to favourites
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </b-card>
            </b-col>
          </template>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<style>
.breadcrumb {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  border-radius: 0;
  color: var(--text-secondary);
  display: none;
}

.row-cols-6 {
  display: flex;
  flex-wrap: wrap;
}

.cursor {
  cursor: pointer;
}
</style>
<script>
import api from "../api";
export default {
  name: 'Home',
  data: () => ({
    url: "",
    user: null,
    username: null,
    dataListFavs: [],
    userEmail: null,
    role: null,
    roles: [],
    services: [],
    apps: [],
    reports: [],
    favourites: [],
    selectedSubMenu: null,
    menu: {}
  }),
  created() {
    this.url = api.Url;
    this.user = JSON.parse(localStorage.getItem("user_data"));
    this.role = (localStorage.getItem("role"));
    var userdata = JSON.parse(localStorage.getItem("user_data"));
    this.username = this.user['email'];
    this.userEmail = this.user['email'];
    if (this.role == null || userdata == null) {
      // This is called from Home - will need to retrieve the data from the session storage and call this if it is not available.
      api.getUserID(userdata.email, (d) => userdata = d, console.error);
      //api.getRoleID(this.role.id, s, console.error);
    }


    let successLinks = (data) => {
      this.allLinks = data;
      console.log(this.allLinks);

      let successFav = (data) => {
        this.allFavourites = data;
        // api.getAllTags(tags_s, console.error);

        // Create a new list with updated objects
        this.favourites = this.allFavourites.map(fav => {
          let linkObject = this.allLinks.find(link => link.id === fav.linkId);
          return {
            id: fav.id,
            link: linkObject
          };
        });
      };

      api.GetUserFavourites(successFav, console.error);
    };


    api.getAllLinks(successLinks, console.error);

    var tags_s = (tags) => {
      
      const allLinksSet = new Set();
      const tagMap = new Map(tags.map(tag => [tag.id, tag]));
      userdata.role.Tags.forEach(userTag => {
        const allowedTag = tagMap.get(userTag.Id);
        if (allowedTag) {
          allowedTag.links.forEach(item => {
            if (item.link.sideBar === true) {
              allLinksSet.add(item.link);
            }
          });
        }
      });
      const links = Array.from(allLinksSet);
      const flatLinks = links.map(({ grouping, ...rest }) => ({
        ...rest,
        parentGroupId: grouping.id,
      }));
      function buildGroupingHierarchy(ogArray, links, parentGroupId = null) {
        const groups = [];
        ogArray.forEach(item => {
          const { grouping, ...rest } = item;
          const groupLinks = [];
          const visitedUrls = new Set();

          links.forEach(link => {
            if (link.parentGroupId === grouping.id && !visitedUrls.has(link.url)) {
              groupLinks.push(link);
              visitedUrls.add(link.url);
            }
          });

          if (groupLinks.length > 0) {
            rest.links = groupLinks;
          }

          rest.showSubMenu = false;
          if (grouping.parentGroupId === parentGroupId) {
            const children = buildGroupingHierarchy(ogArray, links, grouping.id);
            if (children.length > 0) {
              rest.children = children;
            }
            groups.push(rest);
          }
        });
        return groups;
      }
      function extractGroupings(data) {
        const flatArray = [];
        const processedIds = new Set();
        data.forEach(item => {
          const { grouping } = item;
          if (grouping && grouping.id && !processedIds.has(grouping.id)) {
            const flatObject = {
              name: grouping.name,
              grouping: {
                ...grouping
              }
            };
            flatArray.push(flatObject);
            processedIds.add(grouping.id);
            // Check if the parentGroup exists
            const parentGroup = grouping.parentGroup;
            if (parentGroup && parentGroup.id && !processedIds.has(parentGroup.id)) {
              const parentFlatObject = {
                name: parentGroup.name,
                grouping: {
                  ...parentGroup
                }
              };
              flatArray.push(parentFlatObject);
              processedIds.add(parentGroup.id);
            }
          }
        });
        return flatArray;
      }
      const groupings = extractGroupings(links);
      this.menu = buildGroupingHierarchy(groupings, flatLinks);
      
    };

    api.getAllTags(tags_s, console.error);
  },
  methods: {
    toggleSubMenu(menuItem, subMenu) {
      this.selectedSubMenu = subMenu;
      menuItem.showSubMenu = !menuItem.showSubMenu;
    },
    mobileAndTabletCheck() {
      let check = false;
      // eslint-disable-next-line
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    navigateTo(route) {
      var userdata = JSON.parse(localStorage.getItem("user_data"));
      var useremail = (userdata['email']);
      if (route.url.startsWith("Zula")) {
          api.GetZulaDirectSignInUrl(useremail, (url) => { window.open(url, '_blank'); }, console.error);
      }
      else if (route.target === "external") {
        window.open("https://" + route.url, '_blank');
      }
      else {
        if (route.type === "powerbi") {
          if (this.mobileAndTabletCheck()) {
            this.$router.push({ path: "/PowerBiViewer", query: { guid: route.powerBiMobile } })
          } else {
            this.$router.push({ path: "/PowerBiViewer", query: { guid: route.url } })
          }
        }
        else if (route.url.startsWith("invoiceTracker")) {
          this.$router.push({ path: route.url })
          // window.location = "/" + route.url;
        } else if (route.url.includes("vesselTracker")) {
          this.$router.push({ path: '/vesselTracker' })
        } else {
          // window.location = "/IframeViewer?url=" + route.url;
          this.$router.push({ path: '/IframeViewer', query: { url: route.url } })
        }
      }
    },
    addToFavourites(item) {
      const s = (Id) => {
        //Add to favourites array
        this.favourites.push({id: Id, link: item})
        
      };
      
      let user = JSON.parse(localStorage.getItem("user_data"))
      let request = {
        userEmail: user.email,
        linkID: item.id
      }
      api.AddToUserFavourites(request, s, console.error);
    },
    removeFav(item) {
      const s = () => {
        //remove from reports array
        this.favourites = this.favourites.filter((f) => { return f.id != item.id })
      };

      const e = (msg) => {
        console.log("Error message ssssssssssss", msg)
      };

      let request = {
        Id: item.id
      }
      api.RemoveFromUserFavourites(request, s, e);
    }
  }
}
</script>
